export const DEFAULT_ACCOUNTANT_EMAIL = "quickbooks-accountant@simplyinsured.com";

export const intuitBaseUrl = "/intuit/router";
export const intuitAddAccountantUrl = "https://qbo.intuit.com/app/my-accountant";
